import { render, staticRenderFns } from "./BtnAtivarDesativarItemContrato.vue?vue&type=template&id=e786986e"
import script from "./BtnAtivarDesativarItemContrato.vue?vue&type=script&lang=js"
export * from "./BtnAtivarDesativarItemContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports